/* 请求接口API */
import AxiosRequest from '../request/axios.js';

class ApiRequest {
  getData(params, custom) {
    const url = 'api/site/getConfig';
    return AxiosRequest.get(url, params, custom);
  };
}

export default new ApiRequest();


// WEBPACK FOOTER //
// ./src/request/api.js